import { IScoreType } from '@frontend/oxygen/shared-utils';

import { SetsPointsScoreParser } from './sets-points-score-parser';

// ignoring next test as there's an issue with coverage report which shows covered line as uncovered branch
/* istanbul ignore next */
export class GamesPointsScoreParser extends SetsPointsScoreParser {
    protected override type: IScoreType = 'GamesPoints';
}
